import { useAppViewSheetOpener } from "@/v2-backoffice-client/app/app.utils"
import ViewSheet, {
  type ViewSheetProps,
} from "@/v2-backoffice-client/components/viewSheet"
import { APP_VIEW_SHEET_ROUTES } from "@/v2-backoffice-client/app/AppRouter"

export type AppViewSheetProps = Omit<ViewSheetProps, "id">

/**
 * The catalog sheets are editing workbenches (Monaco, and for layers a map
 * preview and AI assistant), not detail cards — they open wide by default.
 * Every kind remembers its own user-resized width (the sheet id keys the
 * storage).
 */
const WIDE_SHEET_KINDS = new Set([
  "layer",
  "layerCreate",
  "basemap",
  "basemapCreate",
  "navLayer",
  "navLayerCreate",
])
const WIDE_SHEET_DEFAULT_WIDTH = 1100

function AppViewSheet(props: AppViewSheetProps) {
  const state = useAppViewSheetOpener()

  const Content = state.kind ? APP_VIEW_SHEET_ROUTES[state.kind] : null

  if (!Content || !state.kind) return null

  const isWide = WIDE_SHEET_KINDS.has(state.kind)

  return (
    <ViewSheet
      // Keyed per kind so the resize state re-initializes when the sheet
      // switches kind. The persisted width bucket (id) is per WIDTH-TIER,
      // not per kind: every wide sheet shares one stored width, every
      // default sheet another.
      key={state.kind}
      id={`app-view-sheet:${isWide ? "wide" : "default"}`}
      defaultWidth={isWide ? WIDE_SHEET_DEFAULT_WIDTH : undefined}
      open
      onOpenChange={(open) => {
        if (!open) state.close()
      }}
      {...props}
    >
      <Content />
    </ViewSheet>
  )
}

export default AppViewSheet
